import EditableTextField from 'components/forms/inputs/EditableTextField';
import React from 'react';
import { useCanEditMatterQuery, useUpdateMatterClientReferenceMutation } from 'store/api/matters';

interface EditableMatterClientReferenceProps {
    matterId: number;
    matterClientReference: string | undefined | null;
}

const EditableMatterClientReference: React.FC<EditableMatterClientReferenceProps> = ({
    matterId,
    matterClientReference,
}) => {
    const [updateMatterClientReference] = useUpdateMatterClientReferenceMutation();
    const { data: isMatterEditableByUser = false } = useCanEditMatterQuery(matterId);

    const handleSave = async (newValue: string) => {
        await updateMatterClientReference({
            id: matterId,
            value: newValue || null,
        }).unwrap();
    };

    return (
        <EditableTextField
            placeholder={'-'}
            value={matterClientReference}
            onSave={handleSave}
            isEditEnabled={isMatterEditableByUser}
        />
    );
};

export default EditableMatterClientReference;
